import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { JSX } from 'react';

export default function LexicalContentEditable({ className }: { className?: string }): JSX.Element {
  return <ContentEditable className={className || 'rteContentRoot__root'} />;
}
